import * as React from "react";
const SvgFiRrPenSwirl = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pen-swirl_svg__a)">
      <path
        fill="#062147"
        d="M8.684 23.485a1 1 0 0 1-1.36.389C2.669 21.288 0 16.96 0 12 0 5.383 5.383 0 12 0c.731 0 1.465.066 2.181.198a1 1 0 0 1-.361 1.967A10 10 0 0 0 12.001 2C6.486 2 2 6.486 2 12c0 4.213 2.294 7.903 6.295 10.126a1 1 0 0 1 .388 1.359zM23.803 9.819a1 1 0 0 0-1.967.361c.109.595.165 1.207.165 1.819 0 3.309-2.691 6-6 6s-6-2.691-6-6a1 1 0 1 0-2 0c0 4.411 3.589 8 8 8s8-3.589 8-8c0-.733-.066-1.467-.198-2.181zm-10.63-3.233L18.879.879c1.133-1.133 3.109-1.133 4.243 0a3.004 3.004 0 0 1 0 4.242l-5.707 5.707A3.97 3.97 0 0 1 14.587 12h-1.586a1 1 0 0 1-1-1V9.414c0-1.068.417-2.073 1.172-2.828M14.001 10h.586c.526 0 1.042-.214 1.414-.586l5.707-5.707a1 1 0 0 0 0-1.414 1.02 1.02 0 0 0-1.414 0L14.586 8c-.378.378-.586.88-.586 1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pen-swirl_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPenSwirl;
